<form role="form" [formGroup]="form" class="form-wrap" (ngSubmit)="onSubmit()">
  <dgx-modal
    [canCancel]="true"
    bodyClasses="guts-p-t-0 "
    [isPendingWithOverlay]="true"
    [useDefaultForm]="false"
    [submitButtonText]="i18n.dgDownloadableReports_GenerateReport"
    [isSubmitDisabled]="form.invalid"
    [isSubmitPending]="isSaving"
    [isLoading]="isLoading"
    submitButtonDgat="createReportModal-835"
  >
    <ng-container class="modal-header">
      {{ i18n.dgDownloadableReports_GenerateReport }}
    </ng-container>

    <ng-container class="modal-body">
      <df-form-root
        class="block guts-p-t-1 guts-p-l-1 guts-p-r-1"
        [form]="form"
        [model]="model"
        [fields]="fields"
        [options]="options"
      >
      </df-form-root>
    </ng-container>
  </dgx-modal>
</form>

<ng-template #reportTypeSelect let-label="label" let-formControl="formControl">
  <div
    *ngFor="let report of availableReports; trackBy: trackByReportId"
    data-dgat="createReportModal-a5f"
    class="selection-box"
  >
    <label class="selection-box__label">
      <input
        type="radio"
        class="selection-box__radio"
        [ngModel]="formControl.value?.reportId"
        [value]="report.reportId"
        (change)="onReportTypeChange(report, formControl)"
        name="report"
        required
        data-dgat="createReportModal-92a"
      />
      <span class="selection-box__text par--small">{{
        report.reportName
      }}</span>
    </label>
  </div>
</ng-template>

<ng-template #dateRangePicker let-label="label" let-formControl="formControl">
  <ng-container
    *ngxComponentOutlet="
      resolver | async | resolve: 'dgxReportingRangePicker';
      context: {
        appearance: 'dropdown',
        disabled: formControl.disabled,
        location: 'Downloadable Reports Modal',
        maxDays: maxSelection,
        selection: onDateRangeSelectionBound(formControl),
        value: formControl.value
      }
    "
  ></ng-container>
</ng-template>

<ng-template #dateRangeDescription let-formControl="formControl">
  <div
    *ngIf="formControl.disabled"
    class="guts-p-b-1"
    id="date-range-description"
  >
    <p class="par par--small par--light">
      {{ i18n.dgDownloadableReports_datePickerText }}
    </p>
  </div>
</ng-template>

<ng-template
  #groupSelect
  let-label="label"
  let-formControl="formControl"
  let-params="params"
>
  <dgx-combobox
    id="chooseGroup"
    class="full-width"
    [selectedOptions]="formControl.value"
    (selections)="onGroupListSelection($event, formControl)"
    [isExactMatchesEnabled]="true"
    [isMultiSelect]="params.isMultiSelect"
    [isFixedWidth]="params.isMultiSelect"
    [options]="availableGroups"
    labelKey="name"
    trackBy="groupId"
    [ariaLabel]="i18n.dgDownloadableReports_ChooseGroup"
    [placeholder]="i18n.dgDownloadableReports_ChooseGroup"
    [hasNoResultsText]="i18n.OrgReportingCtrl_NoMatchingGroups"
    dgatInput="createReportModal-2b3"
  ></dgx-combobox>
</ng-template>

<ng-template
  #reportParametersInput
  let-label="label"
  let-formControl="formControl"
>
  <dgx-reporting-create-report-parameters
    [parameters]="availableReportParameters"
    (update)="onReportParametersUpdate($event, formControl)"
  ></dgx-reporting-create-report-parameters>
</ng-template>
